export default "__VITE_ASSET__DwEY_w1q__"